import { render, staticRenderFns } from "./Debts.vue?vue&type=template&id=483266ef&scoped=true"
import script from "./Debts.vue?vue&type=script&lang=js"
export * from "./Debts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483266ef",
  null
  
)

export default component.exports